import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async updateLetter(id, type, file, token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.API_PHARMACY}/config-footer/letter/${id}/${type}`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
			data: file,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async updateLetterOnlyType(id, type, token) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.API_PHARMACY}/config-footer/letter-only-type/${id}`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
			data: type,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async getLetters(pharmacy, type, page) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/config-footer/letters/${Enviroment.COUNTRY}`,
			params: { pharmacy, type, page },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
